import { search, download } from '../../helpers/api';

export const SERVICE_URI = '/accounts';
export const BASE_URI = '/api/v1/support/internal-corrections';

export const getInternalCorrections = async (data) =>
  search(`${SERVICE_URI}${BASE_URI}`, data);

export const downloadInternalCorrections = async (data) =>
  download(`${SERVICE_URI}${BASE_URI}`, {
    ...data,
    criterias: {
      ...data.criterias,
      download: '',
    },
  });
